









import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'


const CUSTOM = 'custom'


@Component
export default class RateLimitSelect extends Vue {
    @Prop() value!: number
    selectInputValue: string|number|null = null
    CUSTOM = CUSTOM
    rateLimitOptions = [
        {
            text: '3 hours',
            value: 10800
        },
        {
            text: '14 days',
            value: 1209600
        },
        {
            text: '30 days',
            value: 2592000
        },
        {
            text: 'Custom (in seconds)',
            value: CUSTOM
        }
    ]

    mounted() {
        this.selectInputValue = this.selectValue
    }

    get selectValue(): number|string {
        for (const option of this.rateLimitOptions) {
            if (this.value === option.value) {
                return this.value
            }
        }
        return CUSTOM
    }

    @Watch('selectInputValue')
    onSelectInput(value: string|number) {
        if (value !== CUSTOM) {
            this.$emit('input', value)
        }
    }

    @Emit('input')
    onTextFieldInput(value: number): number {
        return +value
    }
}
